import { inject, Injectable } from '@angular/core';

import { UISocketDataMessage } from '../../shared/models/UISocket';
import { SocketAction, SocketActionHandler } from '../../shared/services/SocketActionHandler';
import { DeviceId } from '../models/Device';
import { SiteId } from '../models/Site';
import { SiteDevicesStore } from '../site-devices.store';

interface UISocketDeviceLabelUpdated extends UISocketDataMessage {
    deviceId: DeviceId;
    deviceLabel: string;
    siteId: SiteId;
}

@Injectable()
export class DeviceLabelUpdatedHandler implements SocketActionHandler {
    readonly action: SocketAction = 'deviceLabelUpdated';

    private readonly siteDevices = inject(SiteDevicesStore);

    handle(message: UISocketDeviceLabelUpdated): void {
        this.siteDevices.deviceRenamed(message.siteId, message.deviceId, message.deviceLabel);
    }
}
